import Swal from "sweetalert2";
import { Col, Row } from "antd";
import WriteOrPaste from "./WriteOrPaste";
import { BASEURL } from "../../../../config";
import { useParams } from "react-router-dom";
import { RiDeleteBin6Fill } from "react-icons/ri";
import React, { useState, useEffect } from "react";
import authAxios from "../../../../Config/AuthAxios";
import { MdKeyboardBackspace } from "react-icons/md";
import BatchRunOutput from "../BatchRunOutput/BatchRunOutput";

const UploadFiles = ({
  back,
  isUploadOutComputer,
  pageLoader,
  setPageLoader,
  setBack,
  datauploadComputer,
  setUploadComputerData,
  DragDropfile,
  setDragDropfile,
  isOpenWitreOrPasteDrawer,
  setIsOpenWitreOrPasteDrawer,
  handleWriteOrPasteData,
  setAccessLevel,
  quickrunStatusData,
  setRunStatusMainData,
  showOutput,
  setShowOutput,
}) => {
  const uploadIcon = "/assets/upload-c.svg";
  const editIcon = "/assets/Edit-2.svg";

  const params = useParams();
  const fileInputRef = React.createRef();
  const [BatchProcessing, setBatchProcessing] = useState("");
  const [uploadInitiated, setUploadInitiated] = useState(false);
  let [totalSizeMP4MBArray, settotalSizeMP4MBArray] = useState([]);
  const [QuickSaveExecuteResponse, setQuickSaveExecuteResponse] = useState("");
  const [filesCount, setFilesCount] = useState(0);
  const [uploadedFileCount, setUploadedFileCount] = useState(0);

  useEffect(() => {
    if (isUploadOutComputer && !uploadInitiated && !DragDropfile) {
      fileInputRef.current.click();
      setUploadInitiated(true);
    }
  }, []);

  useEffect(() => {
    const files = DragDropfile;
    uploadFileProcess(files);
  }, [DragDropfile]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    uploadFileProcess(files);
  };

  useEffect(() => {
    if (filesCount === uploadedFileCount) {
      setPageLoader(false);
      setUploadedFileCount(0);
      setFilesCount(0);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [uploadedFileCount, filesCount]);

  const uploadFileProcess = async (files) => {
    await setTimeout(() => {
      setFilesCount(files.length);
    }, 500);

    const allowedFileExtensions = /\.(pdf|txt|doc|docx)$/i;

    if (files) {
      let mp4FilesCount = 0;
      Array.from(files).forEach((file) => {
        if (!allowedFileExtensions.test(file.name)) {
          Swal.fire("Please select valid PDF, MP3, or MP4 files.");
          return;
        }
        if (file.type === "video/mp4") {
          mp4FilesCount++;
          const totalSizeMP4 = file.size / (1024 * 1024);
          totalSizeMP4MBArray.push(totalSizeMP4);
          settotalSizeMP4MBArray(totalSizeMP4MBArray);
        }
      });

      let sum = totalSizeMP4MBArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      if (sum > 300) {
        Swal.fire("The MP4 files size should not exceed 300MB.");
        settotalSizeMP4MBArray([]);
        return;
      }

      Array.from(files).forEach((file) => {
        UploadFileMutiple(
          `quick-action/${params?.id}/run/custom-qa-upload-file`,
          { file }
        );
      });
    }
  };

  const UploadFileMutiple = async (apiUrl, datafile) => {
    setPageLoader(true);
    try {
      const formData = new FormData();
      formData.append("file", datafile.file);

      const token = localStorage.getItem("token");
      const res = await authAxios({
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        method: "POST",
        url: BASEURL + apiUrl,
        data: formData,
      });

      setUploadedFileCount((uploadedFileCount) => uploadedFileCount + 1);
      if (res?.status === 200) {
        const uploadedFileData = res?.data;
        if (uploadedFileData) {
          setUploadComputerData((prevData) => [...prevData, uploadedFileData]);
        }
      }
    } catch (err) {
      const fileError = err?.response?.data?.data?.file[0];
      if (fileError !== undefined) {
        Swal.fire(fileError);
      } else if (err?.status === 500) {
        Swal.fire("Unable to extract data from the file. Please try again.");
      } else if (err?.code === "ERR_NETWORK") {
        Swal.fire("Unable to extract data from the file. Please try again.");
      } else {
        Swal.fire(err);
      }
    }
  };

  const handleDeleteFile = (fileId, index) => () => {
    Swal.fire({
      title: "Are you sure, You want to delete this file? ",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#e53937",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setPageLoader(true);
          const token = localStorage.getItem("token");
          const res = await authAxios({
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            method: "DELETE",
            url: `${BASEURL}quick-action/${fileId}/run/custom-qa-delete-file`,
          });

          if (res?.status === 200) {
            const data = datauploadComputer.filter((file, i) => i !== index);
            setUploadComputerData(data);
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            Swal.fire("File has been deleted successfully!", "", "success");
          }

          setPageLoader(false);
        } catch (err) {
          console.log(err);
          Swal.fire("Something went wrong!", "", "error");
        }
      } else if (result.isDismissed) {
        Swal.fire("Your file is safe!");
      }
    });
    return;
  };

  return (
    <>
      <div className="uploadComputer-data">
        <div
          className="new-workspace-back-master"
          onClick={() => {
            setDragDropfile("");
            setBack();
          }}
        >
          <MdKeyboardBackspace />
          Back
        </div>
        <div className="word-count-data">
          <div className="upload-out-computer-img-height-320">
            <div
              className="upload-out-computer-main-div"
              style={{
                overflowX: "auto",
                maxHeight: "35vh",
              }}
            >
              {datauploadComputer &&
                datauploadComputer?.map((file, index) => (
                  <div key={index} className="">
                    <Row className="d-block upload-out-computer-span">
                      <div className="upload-out-computer-middle-div-first-p">
                        <Col
                          span={12}
                          className="margin-auto"
                          title={file?.file_name}
                        >
                          {file?.file_name.length > 25
                            ? `${file?.file_name.substring(0, 25)}...`
                            : file?.file_name}
                        </Col>

                        {!showOutput ? (
                          <Col span={4} className="margin-auto">
                            <RiDeleteBin6Fill
                              className="upload-out-computer-delete-svg delete-Icon"
                              onClick={handleDeleteFile(file?.file_id, index)}
                            />
                          </Col>
                        ) : (
                          <Col span={4} className="margin-auto"></Col>
                        )}
                      </div>
                    </Row>
                  </div>
                ))}
              {datauploadComputer?.length === 0 && (
                <div className="upload-computer-middle-div-first-p upload-out-computer-span">
                  Please click add more to upload.
                </div>
              )}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              className="file-none"
              multiple
              onChange={handleFileChange}
              accept=".pdf, .txt, .doc, .docx, application/pdf, text/plain, application/msword"
            />
          </div>
          {!showOutput && (
            <div className="m-auto" style={{ marginTop: "15px" }}>
              <button
                onClick={() => fileInputRef.current.click()}
                className="add_more"
              >
                <img src={uploadIcon} alt="" />
                Upload More Files
              </button>
              <button
                className="add_more ml-3"
                onClick={handleWriteOrPasteData}
              >
                <img src={editIcon} alt="" />
                Write or Paste Text
              </button>
            </div>
          )}
        </div>
      </div>

      {showOutput &&
        (quickrunStatusData?.status == "SUCCESS" ? (
          <BatchRunOutput
            data={quickrunStatusData}
            QuickSaveExecuteResponse={QuickSaveExecuteResponse}
            back={back}
            setAccessLevel={setAccessLevel}
            params={params}
            setuplpad={setRunStatusMainData}
            setShowOutput={setShowOutput}
            setBatchProcessing={setBatchProcessing}
          />
        ) : (
          <>
            <h4>Output</h4>
            <div
              style={{
                border: "1px solid red",
                height: "100px",
                padding: "10px",
                borderRadius: "10px",
                fontSize: "16px",
              }}
            >
              {quickrunStatusData?.error_message}
            </div>
          </>
        ))}

      {isOpenWitreOrPasteDrawer && (
        <WriteOrPaste
          isOpenWitreOrPasteDrawer={isOpenWitreOrPasteDrawer}
          setIsOpenWitreOrPasteDrawer={setIsOpenWitreOrPasteDrawer}
          setUploadComputerData={setUploadComputerData}
        />
      )}
    </>
  );
};

export default UploadFiles;
